<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">部品詳細情報</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-sheet elevation="0" class="pa-2">
				<v-row v-if="authority" justify="end" no-gutters>
					<v-btn color="secondary" @click="redirectToComponentEdit">
						<v-icon class="mr-1">mdi-pencil</v-icon>
						編集する
					</v-btn>
				</v-row>
				<table width="100%" class="mt-4 show-dialog-table">
					<tbody>
						<ShowDetailRecord :columnName="'部品名'" :value="component.name" />
						<ShowDetailRecord :columnName="'部品番号'" :value="component.part_number" />
						<ShowDetailRecord
							:columnName="'単価'"
							:value="`${Number(component.unit_price).toLocaleString()}円`"
						/>
						<ShowDetailRecord
							:columnName="'現在個'"
							:value="`${Number(component.stock).toLocaleString()}`"
						/>
						<ShowDetailRecord :columnName="'説明'" :value="component.description" text />
						<ShowDetailRecord
							:columnName="'特定の仕様に属する'"
							:value="component.wildcard ? '属しない' : '属する'"
						/>
						<ShowDetailRecord
							:columnName="'登録日'"
							:value="common.formatDate(component.created_at)"
						/>
						<ShowDetailRecord
							:columnName="'最終更新日'"
							:value="common.formatDate(component.updated_at)"
						/>
					</tbody>
				</table>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	// TODO propsでidを受け取って、ダイアログ内でfetchするパターンも作る
	// このダイアログをどこからでも呼び出せるようにするため
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		authority: {
			type: Boolean,
			required: false,
			default: false,
		},
		id: {
			type: null,
			required: false,
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			component: {},
			common,
		}
	},
	methods: {
		openDialog() {
			this.showDialog = true
		},
		fetchComponent(id) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/components/${id}`
			axios
				.get(url, { headers })
				.then((res) => {
					this.component = res.data.component
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		redirectToComponentEdit() {
			this.$router.push({ name: "component_edit", params: { id: this.id } })
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		id(newVal, oldVal) {
			if (newVal == oldVal) return
			this.fetchComponent(newVal)
		},
		deep: true,
	},
}
</script>
